import { render, staticRenderFns } from "./ScatterPlot.vue?vue&type=template&id=38e54090&"
import script from "./ScatterPlot.vue?vue&type=script&lang=js&"
export * from "./ScatterPlot.vue?vue&type=script&lang=js&"
import style0 from "./ScatterPlot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports